import styled from 'styled-components'

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 350px;
  border-radius: 16px;
  height: 52px;
  width: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #d7e0ea;
  box-shadow: 0 10px 28px rgba(45, 116, 156, 0.08);
`

export const SearchButton = styled.button`
  display: flex;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  height: 52px;
  background: #2d749c;
  color: white;
  padding: 0rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 15px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  cursor: pointer;
  transition: filter 0.18s ease, transform 0.18s ease;

  :hover {
    filter: brightness(1.03);
  }

  :active {
    transform: scale(0.985);
  }
`
